import React, {useContext} from 'react';
import {alpha, styled} from "@mui/material/styles";
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import {useLocation, useNavigate} from "react-router";
import ZiggyContext from "../../store/ziggy-context";
import {IconButton} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';

const Search = styled('div')(({theme}) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({theme}) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({theme}) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}));

const MySearch = () => {
    const ziggyCtx = useContext(ZiggyContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [search, setSearch] = React.useState(ziggyCtx.search || '');

    const handleChangeSearch = (event) => {
        const value = event.target.value;
        setSearch(value);
        ziggyCtx.updateSearch(value);
        if (value && location.pathname !== '/globalsearch') {
            navigate('/globalsearch');
        }
    };

    const handleClearClick = () => {
        setSearch('');
        ziggyCtx.updateSearch('');
        navigate(-1);
    };

    return (
        <Search>
            <SearchIconWrapper>
                <SearchIcon/>
            </SearchIconWrapper>
            <StyledInputBase
                autoFocus={location.pathname === '/globalsearch'}
                placeholder="Search…"
                inputProps={{'aria-label': 'search'}}
                value={search}
                onChange={handleChangeSearch}
                endAdornment={
                    <IconButton
                        sx={{color: 'white', visibility: search ? "visible" : "hidden"}}
                        onClick={handleClearClick}
                    >
                        <ClearIcon/>
                    </IconButton>
                }
            />
        </Search>
    );
};

export default MySearch;